import React from "react";

interface EventListItemProps {
  event: any;
  isGeburtstag: boolean;
  isReadOnly: boolean;
  isGanzTaegig: boolean;
  startTime: string;
  endTime: string;
  onClick: (event: any) => void;
}

const EventListItem: React.FC<EventListItemProps> = ({ event, isGeburtstag, isReadOnly, isGanzTaegig, startTime, endTime, onClick }) => (
  <div
    key={event.id}
    onClick={() => !isReadOnly && onClick(event)}
    className={`event-item ${isGeburtstag ? "event-item-geburtstag" : ""} ${isReadOnly ? "event-item-readonly" : ""}`}
    style={{ cursor: isReadOnly ? "default" : "pointer" }}
  >
    <div
      className="event-color-dot"
      style={{ backgroundColor: event.bgColor || "#3788d8" }}
    />
    <div className="event-title">{event.title}</div>
    <div className="event-time">
      {isGanzTaegig ? "Ganztägig" : `${startTime} - ${endTime}`}
    </div>
  </div>
);

export default EventListItem;
